module.exports = __webpack_public_path__ + "static/media/profile-12.f4b5648a.png";